export default __webpack_public_path__ + "static/img/uccello.9b4edc1.png";